import React from "react";
import { Link } from "gatsby";
require("../styles/pagination.scss");
const Pagination = (props) => {
    const { totalPages, canonicalPath, currentPage, attributes } = props;
    let pages = [];
    for (let i = 1; i <= totalPages; i++) {
        pages.push({
            url: canonicalPath + (i > 1 ? i : ""),
            title: "Consulter la page " + i,
            children: i,
            currentPage: i === currentPage,
        });
    }
    const PrevPage = () => {
        const previous = currentPage - 1;
        return previous > 0 ? (React.createElement(Link, { to: canonicalPath + (previous > 1 ? previous : ""), className: "previous", title: "Consulter la page pr\u00E9c\u00E9dente" }, "Page pr\u00E9c\u00E9dente")) : (React.createElement(React.Fragment, null));
    };
    const NextPage = () => {
        const next = currentPage + 1;
        return next <= totalPages ? (React.createElement(Link, { to: canonicalPath + (next > 1 ? next : ""), className: "next", title: "Consulter la page suivante" }, "Page suivante")) : (React.createElement(React.Fragment, null));
    };
    const style = {};
    if (attributes.layout) {
        style.flexWrap = attributes.layout.flexWrap;
        if (attributes.layout.orientation === "vertical") {
            style.flexDirection = "column";
            style.alignItems =
                attributes.layout.justifyContent === "right"
                    ? "end"
                    : attributes.layout.justifyContent;
        }
        else {
            style.justifyContent = attributes.layout.justifyContent;
            style.flexDirection = "row";
        }
    }
    style.order = (isNaN(props.index) ? 1 : props.index) * 1000;
    return totalPages > 1 ? (React.createElement("div", { id: "pagination", style: style },
        React.createElement(PrevPage, null),
        React.createElement("ul", null, pages.map((e) => (React.createElement("li", { key: e.children }, e.currentPage ? (React.createElement("span", null, e.children)) : (React.createElement(Link, { to: e.url, title: e.title }, e.children)))))),
        React.createElement(NextPage, null))) : (React.createElement(React.Fragment, null));
};
export default Pagination;
